import React from 'react';
import { Loader } from 'components';
import { LandingSvg } from 'assets';

export const ButtonLanding = ({
    className,
    text,
    disabled,
    arrowIcon = false,
    type = 'button',
    onClick,
    load,
    circleSize,
    loadingColor,
}) => {
    return (
        <button
            type={type}
            disabled={disabled || load}
            onClick={onClick}
            className={`button-landing ${className || ''}`}
        >
            {load ? (
                <Loader
                    circleSize={circleSize}
                    loadingColor={loadingColor}
                    styles={{ color: '#FFF' }}
                />
            ) : (
                <div className="flex-all-center">
                    <p className="button-text">
                        {text}
                    </p>

                    {arrowIcon && <LandingSvg.ArrowRightSvg className="arrow-right" />}
                </div>
            )}
        </button>
    );
};
